// export const ReactMdeToolbarCommandsDefault = [
//   ['header', 'bold', 'italic', 'strikethrough'],
//   ['link', 'quote', 'code', 'image'],
//   ['unordered-list', 'ordered-list', 'checked-list'],
// ]

export const ReactMdeToolbarCommands = [
  ['bold', 'italic'],
  ['quote', 'code', 'image'],
  ['unordered-list', 'ordered-list', 'checked-list'],
]

export const ReactMarkdownAllowedElements = ['p', 'strong', 'em', 'li', 'ol', 'ul']
